<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage' :current='page'
      :count='count'>
      <div slot="table">
        <lk-table class="top10" border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal v-model="showDeleteModal" :mask-closable="false" :closable='false' title="删除原因" width="540">
      <lk-form :model="deleteModel" :labelWidth="100">
        <lk-form-item label="产品描述:" prop="reason" style="margin-right: 30px;">
          <lk-input v-model="deleteModel.reason" row="2" type="textarea" :maxlength="100"
            placeholder="请输入至少五个字符"></lk-input>
        </lk-form-item>
      </lk-form>
      <div slot="footer">
        <lk-button @click="showDeleteModal = false, deleteModel.reason = '', deleteId = ''">取消</lk-button>
        <lk-button type='primary' @click="deleteUDI">确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal v-model="showBreakageModal" :mask-closable="false" :closable='false' title="关联报损单号" width="540">
      <lk-form :model="breakageModel" :labelWidth="100">
        <lk-form-item label="报损单号:" prop="orderNum" style="margin-right: 30px;">
          <lk-input v-model="breakageModel.orderNum" row="2" type="textarea" :maxlength="100"
            placeholder="请输入报损单号"></lk-input>
        </lk-form-item>
      </lk-form>
      <div slot="footer">
        <lk-button @click="showBreakageModal = false, breakageModel.orderNum = '', breakageId = ''">取消</lk-button>
        <lk-button type='primary' @click="breakageUDI">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import queryMixins from '@/mixins/queryMixins';
import utils from '@/libs/utils';
import inventory from '../../services/inventory';
import download from '../../services/download';

export default {
  name: 'fakeUdi',
  mixins: [queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      deleteModel: {
        reason: '',
      },
      deleteId: '',
      showDeleteModal: false,
      breakageModel: {
        orderNum: '',
      },
      breakageId: '',
      showBreakageModal: false,
      statusMap: new Map([
        [1, '可销售'],
        [2, '已销售'],
        [3, '已报损'],
        [4, '已删除'],
      ]),
      relateOrderTypeMap: new Map([
        [1, '销售订单'],
        [2, '报损单'],
      ]),
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 80,
          type: 'index',
        },
        {
          title: 'UDI编码',
          key: 'udiCode',
          minWidth: 156,
        },
        {
          title: '录入人',
          key: 'createUser',
          minWidth: 116,
        },
        {
          title: '录入时间',
          minWidth: 136,
          render: (h, { row }) => h('span', utils.exchangeTimeToSecond(row.createTime)),
        },
        {
          title: '当前状态',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => h('span', this.statusMap.get(row.status)),
        },
        {
          title: '关联单据类型',
          key: 'relateOrderType',
          minWidth: 116,
          render: (h, { row }) => h('span', this.relateOrderTypeMap.get(row.relateOrderType)),
        },
        {
          title: '关联单据号',
          key: 'relateOrderCode',
          minWidth: 116,
        },
        {
          title: '操作人',
          key: 'modifiedUserName',
          minWidth: 116,
        },
        {
          title: '操作时间',
          minWidth: 136,
          render: (h, { row }) => h('span', utils.exchangeTimeToSecond(row.modifiedTime)),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 120,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.status !== 1,
              },
              on: {
                click: () => {
                  this.showDeleteModal = true;
                  this.deleteId = row.id;
                },
              },
            }, '删除'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.status !== 1,
              },
              on: {
                click: () => {
                  this.showBreakageModal = true;
                  this.breakageId = row.id;
                },
              },
            }, '报损'),
          ]),
        },
      ],
      query: {},
      tableData: [],
    };
  },
  methods: {
    formatParams() {
      const temp = {};
      temp.page = this.page;
      temp.size = this.size;
      temp.inventoryId = this.$route.params.inventoryId;
      return temp;
    },
    getData() {
      const params = this.formatParams(); // 请求参数添加page，size
      inventory.getUDIList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    /**
     * 删除UDI
     *
     * @returns 无返回值
     */
    deleteUDI() {
      if (this.deleteModel.reason.length < 5) {
        this.$Message.error('请输入删除原因，至少5个字符');
        return;
      }
      const params = {
        operate: 1,
        id: this.deleteId,
        deleteReason: this.deleteModel.reason,
      };
      inventory.operateUDI(params).then((res) => {
        if (res.data.status === 200) {
          this.showDeleteModal = false;
          this.deleteModel.reason = '';
          this.deleteId = '';
          this.$Message.success('删除成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    /**
     * 报损弹窗
     *
     * @returns 无返回值
     */
    breakageUDI() {
      if (!this.breakageModel.orderNum) {
        this.$Message.error('请输入报损单号');
        return;
      }
      const params = {
        operate: 2,
        id: this.breakageId,
        breakageOrder: this.breakageModel.orderNum,
      };
      inventory.operateUDI(params).then((res) => {
        if (res.data.status === 200) {
          this.showBreakageModal = false;
          this.breakageModel.orderNum = '';
          this.breakageId = '';
          this.$Message.success('报损成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less">
.ivu-select-dropdown {
  z-index: 1000;
}

.ivu-menu {
  z-index: 0;
}

.top10 {
  margin-top: 10px;
}
</style>
